"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _order = require("@/api/order.js");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _myDatePicker = _interopRequireDefault(require("@/components/myDatePicker"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    customPage: _customPage.default,
    myDatePicker: _myDatePicker.default
  },
  data: function data() {
    return {
      loading: true,
      searchForm: {
        member_id: '',
        create_time: ''
      },
      total: 0,
      tableData: [],
      editItem: null,
      merchantList: [],
      memberList: [{
        id: '',
        name: '全部'
      }]
    };
  },
  mounted: function mounted() {
    this.getmemberId();
    this.getList();
  },
  methods: {
    getMemberName: function getMemberName(id) {
      var member = this.memberList.find(function (item) {
        return item.id == id;
      });
      return member ? member.name : '';
    },
    getmemberId: function () {
      var _getmemberId2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _order.getmemberId)({});
              case 2:
                res = _context.sent;
                console.log('res', res);
                if (res) {
                  this.memberList = res;
                }
                console.log('this.memberList', this.memberList);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getmemberId() {
        return _getmemberId2.apply(this, arguments);
      }
      return getmemberId;
    }(),
    getList: function getList(flag) {
      var _this = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _order.getOrderRiskCount)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this.loading = false;
        _this.tableData = res.data || [];
        _this.total = res.total;
      });
    },
    // 发券
    openSendCoupon: function openSendCoupon(val) {
      this.editItem = val || null;
      // this.$refs.sendCoupon.dialogVisible = true
    },
    // 编辑
    openEditDialog: function openEditDialog(val) {
      this.editItem = val || null;
      // this.$refs.editDialog.dialogVisible = true
    },
    // 删除
    removeItem: function removeItem(item) {
      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser({ id: item.id }).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 查询
    search: function search() {
      var pickerVal1 = this.$refs.myDatePicker1.getVal();
      if (pickerVal1 !== 'error') {
        this.searchForm.create_time = pickerVal1;
        this.$refs.customPage.page = 1;
        this.getList();
      }
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      if (this.$refs.myDatePicker1) {
        this.$refs.myDatePicker1.reset();
      }
      this.getList();
    }
  }
};
exports.default = _default;